import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, Download, Filter } from 'lucide-react';
import AdminLayout from './AdminLayout';
import { api } from '../../lib/api';
import { fmtDate, StatusBadge } from '../../lib/format';

export default function AdminAppointmentsPage() {
  const [list, setList] = useState([]);
  const [advisors, setAdvisors] = useState([]);
  const [types, setTypes] = useState([]);
  const [filters, setFilters] = useState({ status: '', advisor_id: '', appointment_type_id: '', search: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.adminAdvisors().then(setAdvisors);
    api.adminTypes().then(setTypes);
  }, []);
  useEffect(() => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v));
    api.adminAppointments(params).then(setList).finally(() => setLoading(false));
  }, [filters]);

  return (
    <AdminLayout title="Appointments" subtitle="All scheduled appointments"
      actions={
        <a href={api.exportCsvUrl()} className="inline-flex items-center gap-2 bg-[#14110f] text-white px-4 py-2.5 rounded-md text-[13px] font-semibold hover:bg-[#2a2622] transition">
          <Download className="w-4 h-4" /> Export CSV
        </a>
      }
    >
      <div className="rounded-xl bg-white border border-neutral-100">
        <div className="p-4 border-b border-neutral-100 grid grid-cols-1 md:grid-cols-4 gap-3">
          <div className="relative md:col-span-2">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
            <input value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} placeholder="Search by name, email, company" className="w-full pl-9 pr-3 py-2.5 rounded-md border border-neutral-200 text-[13.5px] focus:border-[#f5b300] outline-none" />
          </div>
          <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })} className="px-3 py-2.5 rounded-md border border-neutral-200 text-[13.5px] focus:border-[#f5b300] outline-none">
            <option value="">All statuses</option>
            {['pending','confirmed','rescheduled','completed','cancelled','no_show'].map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <select value={filters.advisor_id} onChange={(e) => setFilters({ ...filters, advisor_id: e.target.value })} className="px-3 py-2.5 rounded-md border border-neutral-200 text-[13.5px] focus:border-[#f5b300] outline-none">
            <option value="">All advisors</option>
            {advisors.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-[13.5px]">
            <thead className="text-[11px] uppercase tracking-wider text-neutral-400 bg-[#faf6ec]">
              <tr>
                <th className="px-5 py-3 text-left">When</th>
                <th className="px-5 py-3 text-left">Service</th>
                <th className="px-5 py-3 text-left">Client</th>
                <th className="px-5 py-3 text-left">Email</th>
                <th className="px-5 py-3 text-right">Status</th>
              </tr>
            </thead>
            <tbody>
              {loading && (<tr><td colSpan={5} className="py-10 text-center text-neutral-400 text-[13px]">Loading…</td></tr>)}
              {!loading && list.length === 0 && (<tr><td colSpan={5} className="py-10 text-center text-neutral-400 text-[13px]">No appointments match these filters.</td></tr>)}
              {!loading && list.map((a) => (
                <tr key={a.id} className="border-t border-neutral-100 hover:bg-[#faf6ec]/50">
                  <td className="px-5 py-3"><Link to={`/admin/appointments/${a.id}`} className="font-medium text-[#14110f] hover:text-[#c89200]">{fmtDate(a.start)}</Link></td>
                  <td className="px-5 py-3 text-neutral-600">{a.appointment_type_name}</td>
                  <td className="px-5 py-3 text-neutral-700 font-medium">{a.client_first_name} {a.client_last_name}</td>
                  <td className="px-5 py-3 text-neutral-500">{a.client_email}</td>
                  <td className="px-5 py-3 text-right"><StatusBadge status={a.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
